import { CommonLinkButton } from 'components/Button'
import theme from 'theme_'
import Icon from '@mdi/react'
import styled from 'styled-components'

export const TemplateListItemBody = styled.div`
  flex: 1;
  color: ${theme.colors.otterWarmBlack};
  max-width: initial;
  word-break: word;
`
export const TemplateListBtn = styled(CommonLinkButton)`
  display: flex;
`

export const TemplateListRightBlock = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 15px;
  flex: 1;
`

export const TemplateListLeftBlockSecondary = styled.div`
  display: flex;
  flex-direction: column;
  flex: 2;
  gap: 10px;
  width: 100%;

  @media ${theme.devices.mobile} {
    display: none;
  }
`

export const TemplateListLeftBlock = styled.div`
  display: flex;
  flex-direction: column;
  flex: 2;
  gap: 10px;
  width: 100%;

  @media ${theme.devices.mobile} {
    height: 40px;
    padding-left: 30px;
  }
`

export const TemplateListLeftBlockName = styled.div`
  display: flex;
  flex-direction: column;
  flex: 3;
  gap: 10px;
  width: 100%;
  @media ${theme.devices.mobile} {
    flex: 3;
    max-width: 140px;
    white-space: nowrap;
    height: 40px;
    overflow-y: hidden; /* Hide horizontal scrollbar */
    overflow-x: hidden; /* Add vertical scrollbar */
    :hover {
      overflow-x: scroll;
    }
  }
`

export const TemplateListLeftBlockRadio = styled.div`
  display: flex;
  flex-direction: row;
  vertical-align: baseline;
  flex: 1;
  gap: 2px;
  width: 100%;

  @media ${theme.devices.mobile} {
    margin-top: -20px;
  }
`

export const TemplateListIcon = styled(Icon)<{ open?: boolean }>`
  @media ${theme.devices.tablet} {
    display: flex;
  }

  @media ${theme.devices.mobile} {
    display: none;
  }

  @media ${theme.devices.mediumDesktop} {
    display: flex;
  }
`

export const TemplateListRow = styled.div<{ hover?: boolean }>`
  display: flex;
  align-items: center;
  padding: 5px 5px;

  ${({ hover }) => (hover ? 'background:#eeeeee' : 'background:#ffffff')};

  @media ${theme.devices.tablet} {
    gap: 18px;

    ${TemplateListLeftBlock} {
      align-items: center;
      flex-direction: row;
    }
  }
`

export const TemplateSeparator = styled.div`
  height: 1px;
  background-color: ${theme.colors.lightGrey};
`

export const TemplateListDeleteIcon = styled(Icon)`
  @media ${theme.devices.mobile} {
    gap: 1px;
  }
`
